import vue from '@/main' // 引入this
import Vue from 'vue'

const state = {
  receiveList: [],
  totalCounts:0
}

const actions = {
  async getReceiveListAction({ commit }, payload) {
    try {
      const res = await vue.$socket.emit("receive:get", payload);
      commit('SET_RECEIVE', res)
      return res
    } catch (error) {
      throw error
    }
  },
  async createReceiveAction({ commit }, payload) {
    try {
      const res = await vue.$socket.emit("receive:create", payload);
      commit('ADD_NEWRECEIVE', res)
    } catch (error) {
      throw error
    }
  },
  async updateReceiveAction({ commit }, payload) {
    try {
      const newReceive = await vue.$socket.emit("receive:update", {id:payload.id, updateData:payload.data});
      commit("UPDATE_RECEIVE", newReceive)
      return newReceive
    } catch (error) {
      throw error.message
    }
  },
  async deleteReceiveAction({ commit }, payload) {
    try {
      await vue.$socket.emit("receive:delete", payload);
      commit('DELETE_RECEIVE', payload)
      return payload.id
    } catch (error) {
      throw error
    }
  },
  socketAddReceiveAction({ commit }, payload) {
    try {
      commit("ADD_NEWRECEIVE", payload)
    } catch (error) {
      throw error.message
    }
  },
  socketUpdateReceiveAction({ commit }, payload) {
    try {
      commit("UPDATE_RECEIVE", payload)
    } catch (error) {
      throw error.message
    }
  },
  // socketDeleteReceiveAction({ commit }, payload) {
  //   try {
  //     commit("DELETE_RECEIVE", payload)
  //   } catch (error) {
  //     throw error.message
  //   }
  // },
}

const mutations = {
  SET_RECEIVE(state, payload) {
    state.receiveList = payload.receiveList
    state.totalCounts = payload.totalCounts
  },
  ADD_NEWRECEIVE(state, receive) {
    state.receiveList.unshift(receive)
    state.totalCounts++
  },
  UPDATE_RECEIVE(state, receiveList) {
    Vue.set(state.receiveList, state.receiveList.findIndex(x => x._id === receiveList._id), receiveList)
  },
  DELETE_RECEIVE(state, id) {
    state.receiveList = state.receiveList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}